import { Buffer } from 'buffer';

export default function parseJwt(token) {
    if (!token || !token.includes('.')) return {};
    const base64Url = token.split('.')[1]; // token you get
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(Buffer.from(base64, 'base64').toString('binary'));
}
